import React, { Component } from 'react';

import appSettings from '../../config/settings';

import { LoadableComponentErrorBoundaryPage } from './LoadableComponentErrorBoundaryPage';
import SystemErrorPage from '../../containers/SystemErrorPage/SystemErrorPage';

// Use ErrorBoyndary to catch ChunkLoadError
// https://reactjs.org/docs/error-boundaries.html
class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  render() {
    if (this.state.error && this.state.error.name === 'ChunkLoadError') {
      return <LoadableComponentErrorBoundaryPage />;
    }

    if (this.state.error) {
      // A genuine render crash, not a stale-chunk fetch failure. Previously
      // this branch re-rendered this.props.children unchanged, which just
      // threw the same error again, uncaught, one render pass later. Show
      // the system-error page instead, and (during SSR) flag staticContext
      // so server/index.js returns a real 500 rather than a 200 - a crash
      // must not look like a normal successful page load.
      if (this.props.staticContext) {
        this.props.staticContext.serverError = true;
      }
      return <SystemErrorPage />;
    }

    return this.props.children;
  }
}

// LoadableComponentErrorBoundary helps in situations
// where production build changes in the server and
// long-living client app tries to fetch code chunks that don't exist anymore.
// Note: in development mode with Hot Module Reloading (HMR) in use, this causes error loops.
const UseLoadableErrorBoundaryOnlyInProdutionMode = props => {
  const { children, staticContext } = props;
  return appSettings.dev ? (
    children
  ) : (
    <LoadableComponentErrorBoundary staticContext={staticContext}>
      {children}
    </LoadableComponentErrorBoundary>
  );
};
export default UseLoadableErrorBoundaryOnlyInProdutionMode;
